import globalStyles from "../../../../App.module.scss"

import styles from './BashArrays.module.scss'
import React from "react";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

let example1 =`for i in "$\{array[@]}"; do
    if [ "$i" == "foo" ]; then
        echo "Found"
    fi
done`
let example2 =`array=(1 2 3 4)

# Get array length 
arrayLength = $\{#array[@]}

max=$(( arrayLength - 1 ))
min=0

while [[ min -lt max ]]; do
    temp="$\{array[$min]}"
    array[$min]="$\{array[$max]}"
    array[$max]="$temp"

    (( min++, max-- ))
done

# Print the result
echo  "$\{array[@]}"
`

export default function BashArrays() {
    return (
        <div className={styles.bashArrays + ' ' + globalStyles.styledTable}>
            <h1>Arrays in Bash</h1>
            <h5>Regular array</h5>
            <p>declare -a arrayName=(elm1 elm2)</p>
            <b>Bash does not support multidimensional arrays.</b>
            <h5>Associative array</h5>
            <p>declare -A arrayName=([key1]=value1 [key2]=value2)</p>
            <h5>Quick overview</h5>
            <table style={{minWidth: '550px'}}>
                <thead>
                <tr>
                    <th>Syntax</th>
                    <th>Explanation</th>
                </tr>
                </thead>
                <tbody>
                <tr style={{marginLeft: '50px'}}>
                    <td><code>{"arr=()"}</code></td>
                    <td>Instantiate empty array</td>
                </tr>
                <tr>
                    <td><code>{"arr=(1 2 3)"}</code></td>
                    <td>Instantiate array with data</td>
                </tr>
                <tr>
                    {/* eslint-disable-next-line no-template-curly-in-string */}
                    <td><code>{"${arr[2]}"}</code></td>
                    <td>Get element at index '2'</td>
                </tr>
                <tr>
                    {/* eslint-disable-next-line no-template-curly-in-string */}
                    <td><code>{"${arr[@]}"}</code></td>
                    <td>Get all elements</td>
                </tr>
                <tr>
                    {/* eslint-disable-next-line no-template-curly-in-string */}
                    <td><code>{"${!arr[@]}"}</code></td>
                    <td>Get all indices</td>
                </tr>
                <tr>
                    {/* eslint-disable-next-line no-template-curly-in-string */}
                    <td><code>{"${#arr[@]}"}</code></td>
                    <td>Get size</td>
                </tr>
                <tr>
                    <td><code>{"arr[0]=3"}</code></td>
                    <td>Overwrite element at index '0'</td>
                </tr>
                <tr>
                    <td><code>{"arr+=(4)"}</code></td>
                    <td>Append value(s)</td>
                </tr>
                <tr>
                    {/* eslint-disable-next-line no-template-curly-in-string */}
                    <td><code>{"${arr[@]:s:n}"}</code></td>
                    <td>Slice 'n' elements starting at index 's'</td>
                </tr>
                </tbody>
            </table>
            <h4>Examples</h4>
            <h5>Loop over array items</h5>
            <SyntaxHighlighter
                children={example1}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <h5>Reverse an array using first and last swap</h5>
            <SyntaxHighlighter
                children={example2}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
